import React, { useState, useContext, useEffect } from "react";
import Layout from "layouts/LayoutMasterDetail";

import { StoreContext } from "shared/context/store-context";
import { paymentMethods, paymentTypes, banks } from "shared/util/types";
import { getContractYearLabel } from "shared/util/relationaldata";

import ReceiptItem from "./ReceiptItem";

const ReceiptsList = () => {
  const itemType = "receipt";
  const listName = "main_receipts";

  const { receipts, selectedEducationYearId, DeleteReceipt, UpdateReceipt, InsertReceipt } = useContext(StoreContext);

  const [pageItems, setPageItems] = useState();

  useEffect(() => {
    setPageItems(receipts.filter((item) => item?.contract?.year === selectedEducationYearId));
  }, [receipts, selectedEducationYearId]);

  const listColumns = [
    {
      field: "school",
      headerName: "Okul",
      width: 300,
      valueGetter: (params) => {
        try {
          return params.row.contract.school.name;
        } catch (e) {
          return "-";
        }
      },
    },
    {
      field: "year",
      headerName: "Yıl",
      width: 130,
      valueGetter: (params) => {
        try {
          return getContractYearLabel(params.row.contract.year);
        } catch (e) {
          return "-";
        }
      },
    },

    {
      field: "contract",
      headerName: "Öğrenci - Fatura İsmi",
      width: 400,
      valueGetter: (params) => {
        try {
          return `${params?.row.contract.student.name ? params?.row?.contract.student.name : "?"} - ${
            params.row.contract?.payerName ? params.row.contract.payerName : "?"
          }`;
        } catch (e) {
          return "-";
        }
      },
    },
    { field: "amount", headerName: "Meblağ", width: 150 },
    {
      field: "date",
      headerName: "Ödeme Tarihi",
      width: 150,
    },
    {
      field: "paymentMethod",
      headerName: "Ödeme Yöntemi",
      width: 150,

      valueGetter: (params) => {
        try {
          return paymentMethods.find((item) => item.value.toString() === params.row.paymentMethod.toString()).label;
        } catch (e) {
          return "";
        }
      },
    },

    {
      field: "paymentType",
      headerName: "Ödeme Şekli",
      width: 150,

      valueGetter: (params) => {
        try {
          return paymentTypes.find((item) => item.value.toString() === params.row.paymentType.toString()).label;
        } catch (e) {
          return "";
        }
      },
    },

    {
      field: "installmentInfo",
      headerName: "Tek Çekim / Taksit",
      width: 150,
      valueGetter: (params) => {
        try {
          if (params.row.paymentMethod?.toString() !== "2") {
            return "-";
          }
          if (params.row.isSinglePayment === true) {
            return "Tek Çekim";
          }
          if (params.row.isSinglePayment === false) {
            const count = params.row.installmentCount;
            return count ? `Taksitli (${count})` : "Taksitli";
          }
          return "-";
        } catch (e) {
          return "";
        }
      },
    },

    {
      field: "bank",
      headerName: "Banka",
      width: 150,
      valueGetter: (params) => {
        try {
          return banks.find((item) => item.value.toString() === params.row.bank.toString())?.label;
        } catch (e) {
          return "";
        }
      },
    },

    {
      field: "isStudyPayment",
      headerName: "Etüd Tahsilatı",
      width: 120,
      valueGetter: (params) => {
        return params?.row?.isStudyPayment === true ? "Evet" : "Hayır";
      },
    },

    { field: "notes", headerName: "Notlar", width: 150 },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={ReceiptItem}
      NewItemComponent={ReceiptItem}
      DeleteItem={DeleteReceipt}
      InsertItem={InsertReceipt}
      UpdateItem={UpdateReceipt}
      hideCreateNewItemWhenSelected={true}
      showSelectedYear={true}
    />
  );
};

export default ReceiptsList;
